import React from 'react';
import './Spinner.scss';

const Spinner = () => <div className="Spinner"></div>;

export default Spinner;
